import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Gallery from '../components/Gallery';
import CTASection from '../components/CTASection';
import ProcessSteps from '../components/ProcessSteps';
import SpecializedPrograms from '../components/SpecializedPrograms';
import LoanCalculator from '../components/LoanCalculator';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Gallery />
      <CTASection />
      <ProcessSteps />
      <SpecializedPrograms />
      <LoanCalculator />
      <Testimonials />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;
